export default __webpack_public_path__ + "media/wallpaper/three-full-27a99bd7.jpg";